<template>
  <div class="wrapper">
    <div class="icon" :class="{ 'narrow-padding': iconName === 'simcard' }">
      <img :src="icon" :class="{ 'big-icon': iconName === 'plus' }" />
    </div>
    <div class="label">{{ name }}</div>
  </div>
</template>

<script>
export default {
  name: "ProductIcon",
  props: {
    name: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      required: true
    }
  },
  computed: {
    icon() {
      return require(`../../src/assets/${this.iconName}.png`);
    }
  }
};
</script>

<style scoped lang="scss">
.icon {
  &.narrow-padding {
    padding: 15px;
  }
  box-sizing: border-box;
  padding: 40px;
  width: 140px;
  height: 140px;
  background-color: #ffffff;
  border-radius: 20px;
  border: solid 1px #ebebeb;
  display: flex;
  justify-content: center;
  align-items: center;
  & > img {
    width: 100%;
  }
  .big-icon {
    width: 88px;
  }
}

.label {
  padding-top: 18px;
  padding-bottom: 25px;
  text-align: center;
}
</style>
